export function formatMoney(n) {
  const num = Number(n || 0);
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
export function formatInt(n) {
  return Number(n || 0).toLocaleString('en-US');
}
export function prettyPhase(phase) {
  const m = {
    phase_1: 'Phase 1',
    phase_2: 'Phase 2',
    funded: 'Funded Phase',
    awaiting_remainder: 'Awaiting Unlock',
    breached: 'Breached',
  };
  return m[phase] || phase;
}

/**
 * Given an account's plan + current phase, return the label + target for the next request button.
 * Returns null when no upgrade request is possible (funded accounts use payout instead).
 */
export function nextRequestForAccount(account) {
  if (!account) return null;
  if (account.status === 'breached') return null;
  if (account.phase === 'awaiting_remainder') return null;
  if (account.phase === 'funded') {
    return { type: 'payout', label: 'Request Payout', target: 'payout' };
  }
  const plan = account.plan_id;
  const phase = account.phase;
  if (plan === 'core' || plan === 'global') {
    if (phase === 'phase_1') return { type: 'phase_upgrade', label: 'Request Phase 2', target: 'phase_2' };
    if (phase === 'phase_2') return { type: 'phase_upgrade', label: 'Request Funded Phase', target: 'funded' };
  }
  if (plan === 'split' && phase === 'phase_1') {
    return { type: 'split_unlock', label: 'Request Funded Phase', target: 'funded' };
  }
  // Instant accounts don't get phase upgrade buttons; they start funded
  return null;
}

export function prettyPlan(id) {
  const m = { core: 'Core', global: 'Global', instant: 'Instant', split: 'Split Fee' };
  return m[id] || id;
}
export function prettyCertType(t) {
  const m = {
    payout: 'Performance Reward',
    phase_1_passed: 'Phase 1 Passed',
    phase_2_passed: 'Phase 2 Passed',
    funded: 'Performance Trader',
  };
  return m[t] || 'Certificate';
}
